import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void
    onCancel: () => void
}

const OptOutDonorModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Opt-Out Donor Candidate</Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to opt-out donor <strong>{props.fullName}</strong>...
                </div>

                <Alert bsStyle='danger'>
                    This will set the current status to 'Manually Opt Out' and set the Pre-Workup Lab step to 'Stop Communication'.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OptOutDonorModal;